import moment from 'moment';

export const elapsedTime = (startTime: Date | null): number | null => {
  if (!startTime) return null;
  const now = moment();
  const start = moment(startTime);
  if (!start.isValid()) return null;
  const diff = now.diff(start, 'minutes');
  if (diff < 0) return null;
  return diff;
};
